export const COLUMN_SOURCE_ID = 'column';
export const CONDITION_SOURCE_ID = 'condition';
export const DATASET_SOURCE_ID = 'dataset';
export const ERROR_MESSAGE_SOURCE_ID = 'error-message';
export const EXPAND_SOURCE_ID = 'expand';
export const FORMULA_SOURCE_ID = 'formula';
export const FUNCTION_SOURCE_ID = 'function';
export const GROUP_BY_SOURCE_ID = 'groupBy';
export const NAME_SOURCE_ID = 'name';
export const NODE_SOURCE_ID = 'node';
export const OUTPUT_VARIABLES_SOURCE_ID = 'output-variables';
export const SUCCESS_MESSAGE_SOURCE_ID = 'success-message';
export const VALUE_SOURCE_ID = 'value';

/**
 * Source id of one field of one comparison condition: the field's own value, so an error
 * raised while validating a condition can be matched back to the input that produced it.
 *
 * Structurally typed over the condition — the properties editor validates its own
 * in-progress filter-condition shape, not only the persisted query node.
 */
export function getComparisonNodeSourceId<TCondition extends object>(
  condition: TCondition,
  field: keyof TCondition & string,
): string | undefined {
  const value: unknown = field in condition ? condition[field] : undefined;
  return value ? String(value) : undefined;
}
